document.addEventListener('DOMContentLoaded', function () {
  let button = document.querySelector('[data-search-button]');
  const searchInput = document.getElementById('Search');
  const resultsContainer = document.getElementById('predictive-search-results');

  button.addEventListener('click', function(e){
    setTimeout(function(){
      searchInput.focus()
    }, 200);
  })
  if (!searchInput || !resultsContainer) {
    console.error('Search elements not found on page');
    return;
  }

  let searchTimeout = null;
  searchInput.addEventListener('input', function () {
    const term = this.value.trim();
    clearTimeout(searchTimeout);
    if (term.length === 0) {
      resultsContainer.style.display = 'none';
      return;
    }

    searchTimeout = setTimeout(function () {
      resultsContainer.innerHTML = `
        <div class="bg-white border border-gray-200 rounded-lg shadow-lg p-6">
          <div class="flex items-center justify-center">
            <div role="status" class="mr-3">
              <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
              </svg>
              <span class="sr-only">Loading...</span>
            </div>
            <span class="text-sm text-gray-600">Searching...</span>
          </div>
        </div>
      `;
      resultsContainer.style.display = 'block';

      fetch(
        `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product,collection&resources[limit]=10`,
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          // console.log('Search results:', data);
          const products = data.resources.results.products || [];
          const collections = data.resources.results.collections || [];

          if (products.length === 0 && collections.length === 0) {
            resultsContainer.innerHTML = `
              <div class="bg-white border border-gray-200 rounded-lg shadow-lg p-6">
                <div class="text-center">
                  <svg class="mx-auto h-12 w-12 text-gray-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                  </svg>
                  <h3 class="text-sm font-medium text-gray-900 mb-1">No results found</h3>
                  <p class="text-sm text-gray-500">Try adjusting your search terms</p>
                </div>
              </div>
            `;
            return;
          }

          let html =
            '<div class="bg-white border border-gray-200 rounded-lg shadow-lg max-h-96 overflow-y-auto">';

          html += `
            <div class="border-b border-gray-100 p-4">
              <a href="/search?q=${encodeURIComponent(term)}" class="flex items-center p-4 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors duration-150 group">
                <div class="flex-shrink-0 w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center mr-4">
                  <svg class="w-5 h-5 text-gray-500 group-hover:text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                  </svg>
                </div>
                <div class="flex-1">
                  <span class="text-sm font-medium text-gray-900 group-hover:text-black">View all results for "${term}"</span>
                </div>
                <div class="flex-shrink-0 ml-4">
                  <svg class="w-4 h-4 text-gray-400 group-hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                  </svg>
                </div>
              </a>
            </div>
          `;

          if (collections.length > 0) {
            html += '<div class="p-4 border-b border-gray-100">';
            html +=
              '<h3 class="text-xs font-bold uppercase tracking-wide text-gray-500 mb-3">Collections</h3>';
            collections.forEach((collection) => {
              html += `
                <a href="${collection.url}" class="flex items-center p-3 rounded-md hover:bg-gray-50 transition-colors duration-150 group">
                  <div class="flex-shrink-0 w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center mr-4">
                    <svg class="w-5 h-5 text-gray-500 group-hover:text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path>
                    </svg>
                  </div>
                  <div class="flex-1">
                    <span class="text-sm font-medium text-gray-900 group-hover:text-black">${collection.title}</span>
                  </div>
                </a>
              `;
            });
            html += '</div>';
          }

          if (products.length > 0) {
            html += '<div class="p-4">';
            html +=
              '<h3 class="text-xs font-bold uppercase tracking-wide text-gray-500 mb-3">Products</h3>';
            products.forEach((product) => {
              html += `
                <a href="${product.url}" class="flex items-center p-4 rounded-md hover:bg-gray-50 transition-colors duration-150 group">
                  <div class="flex-shrink-0 w-14 h-14 bg-gray-100 rounded-lg overflow-hidden mr-4">
                    ${
                      product.image
                        ? `<img src="${product.image}" alt="${product.title}" class="w-full h-full object-cover">`
                        : `<div class="w-full h-full flex items-center justify-center">
                        <svg class="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                        </svg>
                      </div>`
                    }
                  </div>
                  <div class="flex-1 min-w-0">
                    <div class="text-sm font-medium text-gray-900 group-hover:text-black truncate mb-1">${product.title}</div>
                    <div class="text-sm font-semibold text-gray-900">${product.price}</div>
                  </div>
                  <div class="flex-shrink-0 ml-4">
                    <svg class="w-4 h-4 text-gray-400 group-hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                    </svg>
                  </div>
                </a>
              `;
            });
            html += '</div>';
          }

          html += '</div>';
          resultsContainer.innerHTML = html;
        })
        .catch((error) => {
          console.error('Error fetching search results:', error);
          if (error.status === 429) {
            resultsContainer.innerHTML = `
              <div class="bg-white border border-gray-200 rounded-lg shadow-lg p-6">
                <div class="text-center">
                  <svg class="mx-auto h-12 w-12 text-yellow-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.314 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
                  </svg>
                  <h3 class="text-sm font-medium text-gray-900 mb-1">Too many requests</h3>
                  <p class="text-sm text-gray-500">Please wait and try again</p>
                </div>
              </div>
            `;
          } else {
            resultsContainer.innerHTML = `
              <div class="bg-white border border-gray-200 rounded-lg shadow-lg p-6">
                <div class="text-center">
                  <svg class="mx-auto h-12 w-12 text-red-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                  <h3 class="text-sm font-medium text-gray-900 mb-1">Error loading results</h3>
                  <p class="text-sm text-gray-500">Please try again</p>
                </div>
              </div>
            `;
          }
        });
    }, 300);
  });

  document.addEventListener('click', function (event) {
    if (
      !searchInput.contains(event.target) &&
      !resultsContainer.contains(event.target)
    ) {
      resultsContainer.style.display = 'none';
    }
  });

  searchInput.addEventListener('focus', function () {
    if (
      this.value.trim().length > 0 &&
      resultsContainer.innerHTML.trim() !== ''
    ) {
      resultsContainer.style.display = 'block';
    }
  });
});
